import React from 'react';
import Avatar from 'react-avatar';

const Client = ({ username }) => {
    return (
        <div className="client" title={username}>
            <Avatar name={username} size={36} round="8px" />
            <span className="userName">{username}</span>
        </div>
    );
};

export default Client;
